export default "__VITE_ASSET__D837fBed__"